<template>
    <div class="row d-flex justify-content-between">
        <div class="col-md-12">
            <p>An activation request has been successfully created.</p>
            <p>We will send you an email once the activation is complete.</p>
        </div>
    </div>
</template>

<script>

export default {
    name: "ActivationCompleted",
    props: [],
    data: () => ({
        //
    }),
    methods: {
        redirectToDashboard: _.debounce(function () {
            window.location.href = this.activations_history_url
        }, 1500),
    },
    created() {
        //
    },
    mounted() {
        this.redirectToDashboard()
    },
    computed: {
        //
    },
    watch: {
        //
    }
}
</script>

<style scoped>

</style>